// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_558b7ce7","footer":"rdg_392d672d"};